import { API_URL, jwtToken } from "../../../context/appContext";
export default async function fetchUniswapPairs() {
    return fetch(`${API_URL}/api/uniswapv2_pairs`, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + jwtToken
        }
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
